import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import styles from "./styles.module.scss";
import CaptionTitle from "Root/profile/components/common/CaptionTitle";
import RegFont from "Root/profile/components/common/RegFont";
import Arrow from "Images/profile/arrow-white.svg";
import useCheckoutResultsProduct from "../useCheckoutResultsProduct";
export const NavigationArrows = ({ onChange }) => {
    return (_jsxs("div", { className: styles.arrows, children: [_jsx("button", { onClick: () => onChange(false), children: _jsx("img", { src: Arrow, alt: "" }) }), _jsx("button", { onClick: () => onChange(true), children: _jsx("img", { src: Arrow, alt: "" }) })] }));
};
const CheckoutIngredientsCarousel = ({ ingredients = [], }) => {
    const pagination = {
        clickable: true,
        renderBullet: function (index, className) {
            return `<span class="${className} ${styles[className]}"></span>`;
        },
        horizontalClass: styles.swiper_pagination,
    };
    const { onSwiper, changeSlide } = useCheckoutResultsProduct();
    return (_jsx("div", { className: styles.carousel, children: _jsxs(Swiper, { slidesPerView: 1, onSwiper: onSwiper, pagination: pagination, modules: [Pagination], className: styles.swiper_carousel, loop: true, children: [ingredients.map((ingredient) => (_jsx(SwiperSlide, { children: _jsxs("div", { className: styles.ingredient, children: [_jsx("img", { src: ingredient.image_round, alt: "" }), _jsx(CaptionTitle, { fontWeight: 400, children: ingredient.name }), _jsx(RegFont, { children: ingredient.description })] }) }, ingredient.name))), ingredients.length > 1 && (_jsx("div", { className: styles.arrow_navigation, children: _jsx(NavigationArrows, { onChange: changeSlide }) }))] }) }));
};
export default CheckoutIngredientsCarousel;
